import { makeStyles } from '@mui/styles';

const useEditionPanelStyles = makeStyles({
	root: {
		backgroundColor: 'white',
		boxShadow: '-6px 0px 30px #00000024',
		height: '100vh',
		position: 'fixed',
		right: 0,
		top: 0,
		width: 400,
		zIndex: 1300,
	},
	header: {
		alignItems: 'center',
		borderBottom: '1px solid rgba(112, 112, 112, 0.27)',
		display: 'flex',
		justifyContent: 'space-between',
		paddingBottom: 12,
		paddingLeft: 24,
		paddingRight: 17,
		paddingTop: 16,
		width: '100%',
	},
	titleContainer: {
		maxWidth: 263,
	},
	subTitle: {
		paddingLeft: 8,
	},
	closeButton: {
		backgroundColor: 'transparent',
		border: 0,
		color: '#686868',
		cursor: 'pointer',
		padding: 0,
	},
	body: {
		overflowX: 'hidden',
		overflowY: 'auto',
		scrollbarColor: '#c7c7c7 #E9E9E9',
		scrollbarWidth: 'thin',
		'&::-webkit-scrollbar': {
			width: 6,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#E9E9E9',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#c7c7c7',
			borderRadius: 7,
		},
	},
	actions: {
		alignItems: 'center',
		backgroundColor: 'white',
		borderTop: '1px solid rgba(112, 112, 112, 0.27)',
		bottom: 0,
		display: 'flex',
		gap: 24,
		justifyContent: 'center',
		padding: 24,
		position: 'absolute',
		width: '100%',
		zIndex: 5,
	},
});

export default useEditionPanelStyles;
